import t from 'react-translate';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Button } from 'react-bootstrap';

// redux
import { getFlatCourseAliases } from 'redux/selectors/course';

import NvTextArea from 'shared/components/inputs/nv-text-area';
import NvTextInput from 'shared/components/inputs/nv-text-input';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import ViewValidationError from 'quizzes/components/view-validation-error';
import { AIConfigStep } from '.';

type SetUpBasicsProps = {
  setStep: Function;
};

const SetUpBasics = (props: SetUpBasicsProps) => {
  const { setStep } = props;
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const { formState } = useFormContext();
  const { errors, dirtyFields } = formState;

  const isNextDisabled = !!(errors.title || errors.description) || !(
    dirtyFields.title && dirtyFields.description
  );
  const handleNext = () => {
    setStep(AIConfigStep.SET_UP_INSTRUCTIONS);
  };

  const showDescriptionMaxCharLimitError = () => formState?.errors.description?.type === 'max';

  return (
    <div className='mt-6'>
      <label className='text-large-body bold mb-2 lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.ROLE_PLAY_TITLE()}
      </label>
      <NvTextInput
        withForm
        name='title'
        className='border-gray-5 text-input bg-white required-input'
        inputClassName='text-large-body lh-25'
        required
      />
      <label className='text-large-body bold mb-2 mt-7 lh-25'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.BRIEF_DESCRIPTION(courseAliases)}
      </label>
      <NvTextArea
        withForm
        name='description'
        className='border-gray-5 bg-white required-textarea'
        textareaClassName='min-h-lg lh-30 text-large-body'
        required
      />
      {showDescriptionMaxCharLimitError() && (
        <ViewValidationError characterLimit='10,000' />
      )}
      <div className='d-flex justify-content-center'>
        <Button
          disabled={isNextDisabled}
          type='button'
          className='btn btn-primary mt-8 mb-6'
          onClick={handleNext}
        >
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.NEXT()}
        </Button>
      </div>
    </div>
  );
};

export default SetUpBasics;
